import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';

export const Styled = styled.div`
  ${rtl`
.information-box {
  .left-col-item{
    display: flex;
    margin-bottom: ${toRem(23)};
    padding: 0;
    .left-col-icon{
      &:before{
        padding-right: ${toRem(18)};
        position: relative;
      }
    }
    .temp-icon{
      height: ${toRem(20)};
      padding-right: ${toRem(18)};
    }
    .bold-item{
      a{
        color: ${theme.color['black']};
        text-decoration: underline;
      }
    }
  }
}

@media only ${theme.mediaQuery.smallerTablet} {
  .information-box{
    margin-top: ${toRem(-4)};
    padding-bottom: ${toRem(13)};
    .left-col-item{
      display: flex;
      margin-bottom: ${toRem(25)};
      min-height: ${toRem(19)};
      .left-col-icon{
        &:before{
          padding-right: ${toRem(13)};
          position: relative;
        }
      }
      .left-col-text{
      }
      .bold-item{
        a{
          color: ${theme.color['black']};
        }
      }
      .temp-icon{
        height: ${toRem(14)};
        padding-right: ${toRem(13)};
      }
    }
  }
}

@media only ${theme.mediaQuery.allMobiles} {
  .information-box {
    padding-bottom: ${toRem(13)};
    .left-col-item{
      display: flex;
      margin-bottom: ${toRem(12)};
      height: ${toRem(19)};
      .left-col-icon{
        &:before{
          padding-right: ${toRem(13)};
          position: relative;
        }
      }
      .left-col-text{
      }
      .bold-item{
      }
      .temp-icon{
        height: ${toRem(14)};
        padding-right: ${toRem(13)};
      }
    }
  }
}
.hqv-modal {
  &.information-box{
    margin-top: ${toRem(-4)};
    padding-bottom: ${toRem(13)};
    .left-col-item{
      display: flex;
      margin-bottom: ${toRem(25)};
      min-height: ${toRem(19)};
      .left-col-icon{
        &:before{
          padding-right: ${toRem(13)};
          position: relative;
        }
      }
      .left-col-text{
      }
      .bold-item{
        a{
          color: ${theme.color['black']};
        }
      }
      .temp-icon{
        height: ${toRem(14)};
        padding-right: ${toRem(13)};
      }
    }
  }
}
`}
`;
